import React from "react";
import { Shield, Server, CircleCheck } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
const securityFeatures = [{
  title: "Firmware Sviluppato in Italia",
  description: "Il cuore del sistema Secureasy è progettato e sviluppato interamente in Italia, garantendo i massimi standard di affidabilità e conformità alle normative nazionali.",
  icon: Shield,
  bullets: ["Codice proprietario ultra-sicuro", "Aggiornamenti di sicurezza costanti", "Piena conformità alle leggi italiane"]
}, {
  title: "Hosting su Server Europei",
  description: "I tuoi dati sensibili e le registrazioni video sono archiviati esclusivamente su server localizzati in Europa, nel pieno rispetto del GDPR per la massima privacy.",
  icon: Server,
  bullets: ["Protezione totale dei dati (GDPR)", "Crittografia avanzata end-to-end", "Nessun trasferimento dati extra-UE"]
}];
export default function StandardDiSicurezzaEuropei() {
  return <section id="standard-di-sicurezza-europei" className="bg-background text-foreground py-24 px-4 md:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div className="relative w-full flex justify-center lg:justify-start">
            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3/4 h-3/4 bg-primary/20 blur-[100px] rounded-lg pointer-events-none" />
            
            <div className="relative w-full max-w-md lg:max-w-full aspect-square lg:aspect-[4/5] rounded-2xl overflow-hidden border border-border/50 shadow-2xl shadow-primary/5 bg-card/30 backdrop-blur-sm flex items-center justify-center p-8">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666921/img/secureasy_server_chipset_italy.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666921/img/secureasy_server_chipset_italy.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666921/img/secureasy_server_chipset_italy.png-wvc-sizes" alt="Rappresentazione grafica di un server e chipset Secureasy con design Made in Italy" className="w-full h-full object-contain drop-shadow-xl" loading="lazy" decoding="async" />
            </div>
          </div>

          {}
          <div className="flex flex-col gap-8">
            <div className="mb-4">
              <h2 className="text-3xl md:text-4xl font-default font-bold tracking-tight mb-4">
                Tecnologia Avanzata, <span className="text-primary">Sicurezza Garantita</span>
              </h2>
              <p className="text-muted-foreground text-lg">
                Il sistema di sicurezza Secureasy è progettato per offrire la massima protezione, unendo l'eccellenza ingegneristica italiana con i più rigorosi standard europei sulla privacy.
              </p>
            </div>

            <div className="flex flex-col gap-6">
              {securityFeatures.map((feature, index) => <Card key={index} data-index={index} className="bg-card/40 border-border/50 backdrop-blur-md shadow-lg hover:border-primary/30 transition-colors duration-300">
                  <CardHeader className="pb-4">
                    <div className="flex items-center gap-4 mb-2">
                      <div className="p-3 rounded-lg bg-primary/10 text-primary">
                        <feature.icon className="w-6 h-6" />
                      </div>
                      <CardTitle className="text-xl md:text-2xl font-default">
                        {feature.title}
                      </CardTitle>
                    </div>
                    <p className="text-muted-foreground leading-relaxed">
                      {feature.description}
                    </p>
                  </CardHeader>
                  <CardContent>
                    <ul className="space-y-3">
                      {feature.bullets.map((bullet, bulletIndex) => <li key={bulletIndex} data-index={bulletIndex} className="flex items-start gap-3">
                          <CircleCheck className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                          <span className="text-foreground/90 font-medium">{bullet}</span>
                        </li>)}
                    </ul>
                  </CardContent>
                </Card>)}
            </div>
          </div>

        </div>
      </div>
    </section>;
}